<template>
  <div :class="{up:!showSearch}" class="opera-btn-group">
    <div class="opera-icon">
<!--        <span @click="showSearch = !showSearch" class="pull-left switching-icon">-->
<!--          <i class="el-icon-arrow-up"></i>-->
<!--          <span v-show="showSearch">收起筛选</span>-->
<!--          <span v-show="!showSearch">展开筛选</span>-->
<!--        </span>-->
      <span class="pull-right">
          <des-btn :perm="perm.add" @click="add" custom icon="plus">添加</des-btn>
        </span>
    </div>
<!--    <el-form class="advanced-query-form" onsubmit="return false">-->
<!--      <el-row>-->
<!--        <el-col :span="10">-->
<!--          <oms-form-row :span="3" label="单位">-->
<!--            <el-select :clearable="true" :remote-method="queryUpOrgList" @click.native.once="queryUpOrgList('')"-->
<!--                       filterable-->
<!--                       placeholder="请输入名称/拼音首字母缩写/系统代码搜索单位" popperClass="good-selects"-->
<!--                       remote v-model="searchWord.logisticsCompanyId">-->
<!--              <el-option :key="org.id" :label="org.name" :value="org.id" v-for="org in upOrgList">-->
<!--                <div style="overflow: hidden">-->
<!--                  <span class="pull-left" style="clear: right">{{org.name}}</span>-->
<!--                </div>-->
<!--                <div style="overflow: hidden">-->
<!--                      <span class="select-other-info pull-left">-->
<!--                        <span>系统代码:</span>{{org.manufacturerCode}}-->
<!--                      </span>-->
<!--                </div>-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </oms-form-row>-->
<!--        </el-col>-->
<!--        <el-col :span="12">-->
<!--          <oms-form-row :span="2" label="">-->
<!--            <el-button @click="searchInOrder" native-type="submit" type="primary">查询</el-button>-->
<!--            <el-button @click="resetSearchForm" native-type="reset">重置</el-button>-->
<!--          </oms-form-row>-->
<!--        </el-col>-->
<!--      </el-row>-->
<!--    </el-form>-->
  </div>
</template>
<script>
  import MethodsMix from '@/mixins/methodsMinix';

  export default {
    props: ['perm'],
    mixins: [MethodsMix],
    data() {
      return {
        searchWord: {
          logisticsCompanyId: ''
        },
        showSearch: true
      };
    },
    methods: {
      searchInOrder: function () {// 搜索
        this.$emit('updateFilters', this.searchWord);
      },
      resetSearchForm: function () {// 重置表单
        this.searchWord = {
          logisticsCompanyId: ''
        };
        this.expectedTime = '';
        this.$emit('updateFilters', this.searchWord);
      },
      add() {
        this.$emit('add');
      }
    }
  };
</script>
